import { Theme } from './theme-interfaces';
import COLORS from './colors';

const variableMapping: Theme = {
  primary: '--mf-primary',
  secondary: '--mf-secondary',
  background: '--mf-background',
  backgroundLight: '--mf-bg-light',
  linksColor: '--mf-links',
  headingColor: '--mf-heading-color',
  subHeadingColor: '--mf-sub-heading-color',
  textColor: '--mf-text-color',
  textColorSecondary: '--mf-text-color-secondary',
  textParaColor: '--mf-text-para-color',
  textListColor: '--mf-text-list-color',
  menuBackground: '--mf-menu-background',
  menuBgDark: '--mf-menu-bg-dark',
  boxShadow: '--mf-box-shadow',
  boxShadowSecond: '--mf-snackbar-box-shadow-second',
  headerBackground: '--mf-header-background',
  errorColor: '--mf-error-color',
  borderLightColor: '--mf-border-light-color',
  sucessShadeColor: '--mf-shade-green-color',
  hoverBackgroundColor: '--mf-hover-background-color',
  hoverBorderColor: '--mf-hover-border-color',
  activeBackgroundColor: '--mf-active-background-color',
  activeBorderColor: '--mf-active-border-color',
};

/**
 * Here will be all themes for the project
 */

// KWIKSETUNITE Theme
export const kwiksetunite: Theme = {
  primary: COLORS.RedMain,
  secondary: COLORS.BlackMain,
  background: COLORS.WhiteDark,
  backgroundLight: COLORS.WhiteLight,
  linksColor: COLORS.WhiteMain,
  headingColor: COLORS.BlackMain,
  subHeadingColor: COLORS.BlackMain,
  textColor: COLORS.BlackLight,
  textColorSecondary: COLORS.BlackMain,
  textParaColor: COLORS.GrayMain,
  textListColor: COLORS.GrayExtraLight,
  menuBackground: COLORS.GrayDark,
  menuBgDark: COLORS.GrayExtraDark,
  boxShadow: COLORS.LightGrayLight,
  boxShadowSecond: COLORS.LightGraySecondShade,
  headerBackground: COLORS.BlackMain,
  errorColor: COLORS.RedExtraDark,
  borderLightColor: COLORS.LightOpacityBlack,
  sucessShadeColor: COLORS.GreenShade,
  hoverBackgroundColor: COLORS.LightRed,
  hoverBorderColor: COLORS.LightBorderRed,
  activeBackgroundColor: COLORS.DarkerRed,
  activeBorderColor: COLORS.DarkerBorderRed
};

// WEISER Theme
export const weiser: Theme = {
  primary: COLORS.DarkBlue,
  secondary: COLORS.BlackMain,
  background: COLORS.WhiteDark,
  backgroundLight: COLORS.WhiteLight,
  linksColor: COLORS.WhiteMain,
  headingColor: COLORS.BlackMain,
  subHeadingColor: COLORS.BlackMain,
  textColor: COLORS.BlackLight,
  textColorSecondary: COLORS.BlackMain,
  textParaColor: COLORS.GrayMain,
  textListColor: COLORS.GrayExtraLight,
  menuBackground: COLORS.GrayDark,
  menuBgDark: COLORS.GrayExtraDark,
  boxShadow: COLORS.LightGrayLight,
  boxShadowSecond: COLORS.LightGraySecondShade,
  headerBackground: COLORS.BlackMain,
  errorColor: COLORS.RedExtraDark,
  borderLightColor: COLORS.LightOpacityBlack,
  sucessShadeColor: COLORS.GreenShade,
  hoverBackgroundColor: COLORS.LightBlue,
  hoverBorderColor: COLORS.LightBorderBlue,
  activeBackgroundColor: COLORS.DarkerBlue,
  activeBorderColor: COLORS.DarkerBorderBlue
};

export default variableMapping;
